<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import Table from '@components/newtable'
import { ADMIN_ROLE } from '@utils/constant'
import { ErrorWrapper } from '@utils/error-handler'
import { courseComputed, courseListMethod, authComputed } from '@state/helpers'

export default {
  page: {
    title: 'Calendar',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, Table },
  data() {
    return {
      ADMIN_ROLE: ADMIN_ROLE,
      isLoading: true,
      lists: [],
      fields: [
        {
          value: 'title',
          text: 'Title',
          sortable: true,
          colType: 'default',
        },
        {
          value: 'start',
          text: 'Start Date',
          sortable: true,
          colType: 'date',
        },
        {
          value: 'end',
          text: 'End Date',
          sortable: true,
          colType: 'date',
        },
        {
          value: 'action',
          text: 'Action(s)',
          sortable: false,
          colType: 'button',
        },
      ],
      displayFields: [
        { key: 'title', label: 'Title', colType: 'default' },
        { key: 'start', label: 'Start Date ', colType: 'date' },
        { key: 'end', label: 'End Date ', colType: 'date' },
      ],
    }
  },
  computed: {
    ...courseComputed,
    ...authComputed,
  },
  mounted() {
    this.getListOfEvents()
  },
  methods: {
    ...courseListMethod,

    // Get list of all courses role wise
    getListOfEvents() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 10,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCalendarEventList({ filter })
        .then((calendarEventList) => {
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="isLoading" :opacity="0.6" rounded="sm">
          <b-card>
            <router-link
              tag="button"
              to="/calendar-event-add"
              class="btn btn-info mb-2"
            >
              <i class="ti-plus"></i><span> Add Event</span> </router-link
            >&nbsp;
            <router-link tag="button" to="/calendar" class="btn btn-info mb-2">
              <i class="ti-eye"></i><span>&nbsp;Calendar</span> </router-link
            >&nbsp;
            <Table
              :fields="fields"
              :items="calendarEventList ? calendarEventList.docs : []"
              :editbtn="true"
              :viewbtn="true"
              :deletebtn="true"
              :calendar-event="true"
              :display-fields="displayFields"
            >
            </Table>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
